/**
 * useCommandFeed — manages the command feed entries list.
 * Extracted from App.tsx — pure structural refactor.
 */

import { useState } from "react";

export type CommandFeedEntry = {
  id: string;
  text: string;
};

export function useCommandFeed() {
  const [commandFeed, setCommandFeed] = useState<CommandFeedEntry[]>([]);

  function appendCommandFeed(text: string) {
    if (!text.trim()) {
      return;
    }

    setCommandFeed((currentFeed) => [
      ...currentFeed.slice(-11),
      {
        id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        text,
      },
    ]);
  }

  function clearCommandFeed() {
    setCommandFeed([]);
  }

  return { commandFeed, appendCommandFeed, clearCommandFeed };
}
